export default __webpack_public_path__ + "static/media/img-page1.9dee62a7.png";